import React from 'react'
import { LoadingSpinner } from '@paypalcorp/pp-react'

const SuspenseFallback = () => {
  const options = {
    screenReaderText: 'Page is loading.',
  }
  return <LoadingSpinner {...options} />
}

export default SuspenseFallback
